import { FC, useContext } from 'react'
import map from 'lodash/map'

import StreamContext from 'shared/contexts/StreamContext'
import Toggle from 'shared/components/Toggle'

type Props = {
  /** Show the mic on/off switch above the device list. */
  showToggle?: boolean
  disabled?: boolean
}

/**
 * Microphone chooser: a radio list of available input devices, optionally with
 * a mute/unmute toggle. Reads everything from StreamContext, so it works both
 * inside the control panel and as a standalone recovery picker (e.g. opened
 * from the "we can't hear you" banner when the control panel is hidden).
 */
const MicDevicePicker: FC<Props> = ({ showToggle = false, disabled = false }) => {
  const { microphones, selectedMicId, changeMicId, controls, changeControls } =
    useContext(StreamContext)

  return (
    <>
      {showToggle && (
        <Toggle
          label='Microphone'
          on={controls.mic}
          disabled={disabled}
          onChange={(next) => changeControls({ ...controls, mic: next })}
        />
      )}
      <div className={showToggle ? 'mt-2 border-t border-whiteAlpha-300 pt-2' : ''}>
        {microphones.length === 0 && (
          <p className='text-sm text-whiteAlpha-600'>No microphones found</p>
        )}
        {map(microphones, (d) => (
          <div
            className='flex items-center mb-3'
            key={d.deviceId}
            onClick={() => changeMicId(d.deviceId)}
          >
            <input
              id={`mic_${d.deviceId}`}
              type='radio'
              value={d.deviceId}
              name='microphone'
              className='w-4 h-4 text-teal-400 focus:ring-0 accent-[#38B2AC]'
              checked={selectedMicId === d.deviceId}
              onChange={() => changeMicId(d.deviceId)}
            />
            <label
              htmlFor={`mic_${d.deviceId}`}
              className='ms-2 text-sm font-medium text-white'
            >
              {d.label || 'Microphone'}
            </label>
          </div>
        ))}
      </div>
    </>
  )
}

export default MicDevicePicker
